module.exports = __webpack_public_path__ + "static/media/resume.56ba0ad3.pdf";